module.exports = __webpack_public_path__ + "img/sixpackcarrier99.c8cf8131.jpg";